import { deviceApi } from '@/redux/api/endpoints/device';
import { selectOrganisationById } from '@/redux/api/seletors/select-organisation-by-id';
import { QueryHandler } from '@/redux/types/query-handler';
import { updateItemRecipe } from '@/redux/utils/update-item-recipe';
import { DeviceUnassociated } from '@/types/device';
import { AddDeviceToOrganisationQueryArg } from '../types/query-arg';

export const handleResultAddDeviceToOrganisation: QueryHandler<
  AddDeviceToOrganisationQueryArg,
  void
> = async (queryArg, { queryFulfilled, ...api }) => {
  const organisation = selectOrganisationById(queryArg.organisationId)(
    api.getState(),
  );

  const patch = api.dispatch(
    // Only Platform Admin is able to call addDeviceToOrganisation so we don't need an organisationId passed to updateQueryData
    deviceApi.util.updateQueryData(
      'getUnassociatedDevices',
      {},
      updateItemRecipe<DeviceUnassociated, 'id'>('id', queryArg.device.id, {
        organisation,
      }),
    ),
  );

  try {
    await queryFulfilled;
  } catch (err) {
    patch.undo();
    throw err;
  }
};
